module.exports = __webpack_public_path__ + "static/media/timer-short-beep.c3336ef3.wav";